import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {I18nModule, UrlModule} from '@spartacus/core';
import {IconModule, MediaModule} from '@spartacus/storefront';
import {AimoSpinnerModule} from '../spinner/aimo-spinner.module';

import {AimoCarouselComponent} from './aimo-carousel.component';
import {AimoBannerModule} from "../banner/aimo-banner.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        IconModule,
        MediaModule,
        UrlModule,
        I18nModule,
        AimoSpinnerModule,
        AimoBannerModule,
    ],
    declarations: [AimoCarouselComponent],
    exports: [AimoCarouselComponent],
})
export class AimoCarouselModule {}
